<template>
	<div id="app">
		<BookeeTypeFilter :filter="filter" />
		<BookeeProduct :filter="filter" />
	</div>
</template>

<script>
import BookeeTypeFilter from './components/BookeeTypeFilter.vue';
import BookeeProduct from './components/BookeeProduct.vue';


export default {
	name: 'app',
	components: {
		BookeeTypeFilter,
		BookeeProduct
	},
	data () {
		return {
			filter: []
		};
	}
};
</script>

<style lang="scss">

	#app {
		overflow: hidden;
		height: 100vh;
	}

	.button {
		cursor: pointer;
		&__arrow {
			width: .8rem;
			height: .8rem;
			fill: $filter_txt_active;
			vertical-align: middle;
			position: relative;
			top: -.12em;
			margin-left: .3em;
		}
	}
</style>
